import { useToast } from '@components/index'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { settlementsQueryKey } from '../queries/useSettlements'

export const settlementsUrl = SNA_PREFIX + 'settlements'

/**
 * Every settlement mutation does the same three things afterwards: toast,
 * invalidate the settlement queries, surface backend error keys. This keeps
 * each hook to its request.
 */
export function useSettlementMutation<TVariables, TData>({
  request,
  toastKey
}: {
  request: (variables: TVariables) => Promise<TData>
  toastKey: string
}) {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  return useMutation({
    mutationFn: request,
    onSuccess: () => {
      toast.success({ message: t(toastKey) })
      queryClient.invalidateQueries({ queryKey: settlementsQueryKey })
    },
    onError
  })
}
